import { useMemo } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished, getIsPublishing, getIsArchived, getIsFullySignedPaidOrProcessing, getIsAccepted } from 'quotes-ui-lib/utils/status';
import { getHasDeal } from 'quotes-ui-lib/utils/quote';
import { hasDeprecatedTemplateType as getHasDeprecatedTemplateType } from 'quotes-ui-lib/utils/templates';
import { jsx as _jsx } from "react/jsx-runtime";
const RecallAndEditButton = ({
  quote,
  onClick
}) => {
  const hasDeal = getHasDeal(quote);
  const hasDeprecatedTemplateType = getHasDeprecatedTemplateType(quote);
  const isFullySignedPaidOrProcessing = getIsFullySignedPaidOrProcessing(quote);
  const disabledTooltipTitleKey = useMemo(() => {
    let translationKey = '';
    if (isFullySignedPaidOrProcessing) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.recallSignedTooltip';
    } else if (!hasDeal) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.noDealTooltip';
    } else if (hasDeprecatedTemplateType) {
      translationKey = 'quotesUiLib.quoteActions.recallAndEdit.deprecatedTemplateTooltip';
    }
    return translationKey;
  }, [isFullySignedPaidOrProcessing, hasDeal, hasDeprecatedTemplateType]);
  const disableButton = !!disabledTooltipTitleKey;
  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledTooltipTitleKey
    }),
    disabled: !disableButton,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "recall-quote-btn",
      "data-selenium-test": "recall-quote-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: handleButtonClick,
      disabled: disableButton,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "recall-quote-btn-text",
        message: "quotesUiLib.quoteActions.recallAndEdit.buttonText"
      })
    }, "recallButton")
  }, "recall");
};
export const showRecallAndEditButton = (quote, canCurrentUserEditQuote) => {
  const isPublished = getIsPublished(quote);
  const isPublishing = getIsPublishing(quote);
  const isArchived = getIsArchived(quote);
  const isAccepted = getIsAccepted(quote);
  const isRecallable = isPublished && !isArchived && !isAccepted || isPublishing;
  return canCurrentUserEditQuote && isRecallable;
};
export default RecallAndEditButton;